module.exports = __webpack_public_path__ + "static/preview-captio-167fb5055c15ec8e3be36aad3f4e8c74.png";